[].slice.call(document.querySelectorAll('form.site-search')).forEach(function(searchForm) {
	var searchInput = searchForm.querySelector('input');

	searchForm.addEventListener('submit', function(e) {
		e.preventDefault();

		if(searchInput.value !== '')
			window.location.href = '/search?q='+searchInput.value+'#search-results';
		else
			searchInput.classList.add('error');
	});

	//  Sliding Search Form
	// searchForm.querySelector('button').addEventListener('click', function() {
	// 	if(this.classList.contains('open') && searchInput.value === '') {
	// 		this.classList.remove('open');
	// 		searchInput.setAttribute('aria-hidden', 'true');
	// 		searchInput.setAttribute('tabindex', '-1');
	// 	}
	// 	else {
	// 		this.classList.add('open');
	// 		searchInput.setAttribute('aria-hidden', 'false');
	// 		searchInput.removeAttribute('tabindex');
	// 		searchInput.focus();
	// 	}
	// });
});